module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/ceremony-plan-3-og-image-6692a2bad7293978fa2a137f316d042f.png";